import { Mapper } from '../../../../base/utils/mapper';
import { ComercialPagedModel } from '../../../../domain/models/comercial/comercial-paged.model';
import { ComercialPagedEntity } from '../entities/comercial-paged.entity';

export class ComercialPagedImplementationRepositoryMapper extends Mapper<ComercialPagedEntity, ComercialPagedModel> {
  mapFrom(param: ComercialPagedEntity): ComercialPagedModel {
    return {
      data: param.data,
      isSuccess: param.isSuccess,
      message: param.message,
      showMessage: param.showMessage,
      errors: param.errors,
      pagination: param.pagination
    };
  }

  mapTo(param: ComercialPagedModel): ComercialPagedEntity {
    return {
      data: param.data,
      isSuccess: param.isSuccess,
      message: param.message,
      showMessage: param.showMessage,
      errors: param.errors,
      pagination: param.pagination
    };
  }
}
